/** Shared type guard for the P2P transfer parsers (untrusted JSON). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
